<div>
  <img
    [src]="
      image
        ? image.thumbnail.url
        : type === NotificationTypes.SUCCESS
          ? 'assets/icon-done.svg'
          : 'assets/icon-error.svg'
    "
    [width]="image ? image.thumbnail.width : 512"
    [height]="image ? image.thumbnail.height : 512"
    [alt]="
      image
        ? image.name
        : type === NotificationTypes.SUCCESS
          ? 'Success icon'
          : 'Error icon'
    "
  />
</div>
<div>
  <strong
    class="title"
    [class.title_successful]="type === NotificationTypes.SUCCESS"
    [class.title_error]="type === NotificationTypes.ERROR"
  >
    {{ title }}
  </strong>
  <p>
    {{ message }}
  </p>
</div>
